import { render, staticRenderFns } from "./statues-page.vue?vue&type=template&id=85e9a6d8&scoped=true&lang=pug&"
import script from "./statues-page.vue?vue&type=script&lang=js&"
export * from "./statues-page.vue?vue&type=script&lang=js&"
import style0 from "./statues-page.vue?vue&type=style&index=0&id=85e9a6d8&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "85e9a6d8",
  null
  
)

export default component.exports